import { DEFAULT_OPTIONS } from "./constants";
import Alea from "alea";
import SimplexNoise from "simplex-noise";
import { getSeed, initRandom } from "./utils";
import { Bounds, Vector } from "./vector";

const sizeCanvas = (
  canvas,
  { width, height, dpr, browser, padding } = opts
) => {
  if (browser) {
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
  }

  canvas.getContext("2d").scale(dpr, dpr);
  canvas.getContext("2d").translate(padding, padding);
};

export const setup = async (getComponents, opts = {}) => {
  const options = {
    ...DEFAULT_OPTIONS,
    ...opts,
  };

  const seed = options.seed || getSeed();
  const random = new Alea(seed);

  initRandom(random);

  // const components = await options.browser ? getBrowserComponents() : Promise.resolve();
  const components = await getComponents(options);

  sizeCanvas(components.canvas, options);

  return {
    getOptions: () => ({
      ...options,
      width: options.width - options.padding * 2,
      height: options.height - options.padding * 2,
      get dotWidth() {
        return this.width / options.dotsPerRow;
      },
      get dotHeight() {
        return this.dotWidth * 0.75;
      },
      get dotsPerColumn() {
        return this.height / this.dotHeight;
      },
      get seed() {
        return seed;
      },
      get bounds() {
        return new Bounds(
          new Vector(0, 0),
          new Vector(this.dotsPerRow, this.dotsPerColumn)
        );
      },
    }),
    getComponents: () => ({
      ...components,
      random,
      noise: new SimplexNoise(random),
    }),
  };
};
